import cx from 'classnames'
import React from 'react'

export const TextArea = ({
  className,
  ...other
}: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>) => {
  return (
    <textarea
      className={cx(
        'bg-input-background border-solid border border-input-border text-french-blue-base text-base leading-6 text-sm rounded-lg outline-none block w-full px-4 py-3 placeholder:text-input-placeholder placeholder:text-base placeholder:leading-6 hover:border-gray-3 focus:border-theme',
        className
      )}
      {...other}
    />
  )
}
